module.exports = __webpack_public_path__ + "img/wait-time.38ae2ef6.png";